import Card from '@/components/base/card/card.component';
import CardHeader from '@/components/base/card/card-header.component';
import { CircularLoaderContainer } from '@/components/base/circular-loader-container.component';
import {
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { DeliveryDining as DeliveryDiningIcon } from '@mui/icons-material';
import dayjs from 'dayjs';
import { formatMoneyString } from '@/utils/format-money-string';
import { SapDocument } from '@/api/documents/documents.types.ts';
export default function DeliveryNotes({
  deliveryNotes,
  isPending,
}: {
  deliveryNotes: SapDocument[];
  isPending: boolean;
}) {
  if (isPending) {
    return (
      <Card>
        <CardHeader title="Lieferscheine" />
        <CircularLoaderContainer />
      </Card>
    );
  }
  if (deliveryNotes.length === 0) {
    return null;
  }

  return (
    <Card elevation={2} sx={{ borderRadius: 3, overflow: 'hidden' }}>
      <CardHeader icon={<DeliveryDiningIcon />} title="Lieferscheine" />
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Lieferscheinnummer</TableCell>
              <TableCell>Datum</TableCell>
              <TableCell>Versandkosten</TableCell>
              <TableCell>Betrag</TableCell>
              <TableCell>Tracking</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {deliveryNotes.map((item) => {
              const shippingExpense = item.documentAdditionalExpenses?.find(
                (expense) =>
                  expense?.expenseCode === 2 || expense?.expenseCode === 4,
              );
              return (
                <TableRow key={item.docNum}>
                  <TableCell>{item.uLieferscheinNrBvw}</TableCell>
                  <TableCell>
                    {dayjs(item.docDate).format('DD.MM.YYYY')}
                  </TableCell>
                  <TableCell>
                    {shippingExpense
                      ? formatMoneyString(shippingExpense.lineGross)
                      : '-'}
                  </TableCell>
                  <TableCell>{formatMoneyString(item.docTotal)}</TableCell>
                  <TableCell>
                    <Link
                      href={item.uLinkTracking ?? ''}
                      sx={{
                        whiteSpace: 'pre-wrap',
                      }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.uTrackingNr?.split(':').join('\n')}
                    </Link>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
}
